import * as yup from "yup";

const slovenian = {
  mixed: {
    required: "Polje je obvezno",
    default: "Vrednost ni veljavna",
    notType: "Polje je obvezno",
    oneOf: "Vrednost mora biti ena izmed: ${values}",
    notOneOf: "Vrednost ne sme biti ena izmed: ${values}",
    defined: "Vrednost mora biti definirana",
    notNull: "Polje je obvezno",
  },
  string: {
    required: "Polje je obvezno",
    min: "Minimalna dolžina je ${min} znak(ov)",
    max: "Največja dolžina je ${max} znak(ov)",
    length: "Dolžina mora biti točno ${length} znak(ov)",
    email: "Napačen e-poštni naslov",
    url: "Napačna URL povezava",
    trim: "Vrednost ne sme vsebovati začetnih ali končnih presledkov",
    lowercase: "Vrednost mora biti v malih črkah",
    uppercase: "Vrednost mora biti v velikih črkah",
    matches: "Vrednost mora ustrezati vzorcu: ${regex}",
  },
  number: {
    min: "Število mora biti večje ali enako ${min}",
    max: "Število mora biti manjše ali enako ${max}",
    lessThan: "Število mora biti manjše od ${less}",
    moreThan: "Število mora biti večje od ${more}",
    positive: "Število mora biti pozitivno",
    negative: "Število mora biti negativno",
    integer: "Vrednost mora biti celo število",
  },
  date: {
    min: "Datum mora biti večji od ${min}",
    max: "Datum mora biti manjši od ${max}",
    invalidType: "Napačen tip datuma",
    cannotBeInFuture: "Datum ne sme biti v prihodnosti",
  },
  array: {
    min: "Seznam mora vsebovati vsaj ${min} elementov",
    max: "Seznam lahko vsebuje največ ${max} elementov",
    length: "Seznam mora imeti točno ${length} elementov",
  },
  object: {
    noUnknown: "Polje ne sme vsebovati neznanih ključev",
  },
};

yup.setLocale(slovenian);
